import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
// routes
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import { StyledChart } from "./components/chart";
import ScrollToTop from "./components/scroll-to-top";
import { BudgetProvider } from "./Context/BudgetContext";
import { ProfileProvider } from "./Context/ProfileContext";
import { SearchProvider } from "./Context/SearchContext";
import { CardDialogProvider } from "./Context/CardDialogContext";

// Import auth test utilities for development (only in development mode)
if (process.env.NODE_ENV === "development") {
  import("./utils/authTestUtils.js");
}

// ----------------------------------------------------------------------

export default function App() {
  return (
    <ProfileProvider>
      <BudgetProvider>
        <SearchProvider>
          <CardDialogProvider>
            <HelmetProvider>
              <BrowserRouter>
                <ThemeProvider>
                  <ScrollToTop />
                  <StyledChart />
                  <Router />
                  <ToastContainer />
                </ThemeProvider>
              </BrowserRouter>
            </HelmetProvider>
          </CardDialogProvider>
        </SearchProvider>
      </BudgetProvider>
    </ProfileProvider>
  );
}
